import { Controller } from "@hotwired/stimulus"

import { tryParseJSON } from "../helpers/utils"

const TRUSTPILOT_ORIGIN = "https://widget.trustpilot.com"
const TRUSTPILOT_IMPRESSION_COMMAND = "impression"

export default class TrustpilotController extends Controller {
  static targets = ["fallback"]
  declare readonly fallbackTarget: HTMLElement

  hideFallbackIfLoaded({ data, origin, source }: MessageEvent): void {
    if (origin !== TRUSTPILOT_ORIGIN) {
      return
    }

    const iframe = this.element.querySelector("iframe")

    if (!iframe || source !== iframe.contentWindow) {
      return
    }

    try {
      const { command } = tryParseJSON(data || {}) as { command?: string }

      if (command === TRUSTPILOT_IMPRESSION_COMMAND) {
        this.fallbackTarget.hidden = true
      }
    } catch {
      // Do nothing
    }
  }
}
